'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { getUnlocalizedPath } from '@src/i18n/locale.util';
export function useUnlocalizedPathname() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = getUnlocalizedPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}